import React from "react";
import PropTypes from "prop-types";
import WmsButton from "../WmsButton/WmsButton.jsx";
import { IMPORT_LINE_ITEM_LIMIT } from "./importLineItemLimit.js";
import "../WmsConfirmModel/WmsConfirmModel.scss";
import "./ImportLineItemWarningModal.scss";

/**
 * Pure React modal — avoids kendoWindow DOM reparenting (TW-38398 insertBefore/removeChild crashes).
 */
export default function ImportLineItemWarningModal({ id, isOpen, onConfirm, onCancel }) {
    if (!isOpen) {
        return null;
    }

    const translate = window.translate;
    const title = translate("Label_Import_LineItemWarning_Title");
    const body = translate("Label_Import_LineItemWarning_Body")
        .replace("%limit%", String(IMPORT_LINE_ITEM_LIMIT))
        .replace(/&lt;br\s*\/?&gt;/gi, "<br/>");

    return (
        <div
            className="import-line-item-warning-overlay areYouSureZindex"
            data-testid="line-item-warning-modal"
            role="presentation"
            onClick={onCancel}
        >
            <div
                className="import-line-item-warning-dialog confirmation-wrapper"
                id={id}
                role="dialog"
                aria-modal="true"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="confirmation-model wms-warning-notification">
                    <div className="wms-notification-warning-header wms-warning-header-color">{title}</div>
                    <div className="wms-area-content">
                        <div className="note">
                            <div dangerouslySetInnerHTML={{ __html: body }} />
                        </div>
                    </div>
                    <div className="wms-notification-warning-toolbar wms-toolbar">
                        <div className="wms_half_part">
                            <WmsButton
                                label={translate("Label_Cancel")}
                                onClickFunc={onCancel}
                                icon="fa-ban"
                                buttonType="orange"
                                wmsSelector="lineItemWarningCancel"
                            />
                        </div>
                        <div className="wms_half_part">
                            <WmsButton
                                label={translate("Label_Select_Confirm")}
                                onClickFunc={onConfirm}
                                icon="fa-check-circle"
                                buttonType="green"
                                wmsSelector="lineItemWarningConfirm"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

ImportLineItemWarningModal.propTypes = {
    id: PropTypes.string.isRequired,
    isOpen: PropTypes.bool.isRequired,
    onConfirm: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
};
